import { render, staticRenderFns } from "./exhibition_list.vue?vue&type=template&id=1cee545c&scoped=true&"
import script from "./exhibition_list.vue?vue&type=script&lang=js&"
export * from "./exhibition_list.vue?vue&type=script&lang=js&"
import style0 from "./exhibition_list.vue?vue&type=style&index=0&id=1cee545c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cee545c",
  null
  
)

export default component.exports